/**
 * The old Stores Utility (user, 2026-10-30: folded into Reports). Its links keep working: Sub-Bin
 * Card goes to Reports ▸ Sub-Bin Card, SLOC Search and Stores Item Search to the SLOC Status report.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const id = z.coerce.number().int().positive().optional().catch(undefined);
export const Route = createFileRoute("/_app/stores/utility")({
  validateSearch: z.object({
    tab: z.string().optional().catch(undefined),
    whId: id,
    binId: id,
    subBinId: id,
    classificationId: id,
    itemId: id,
    from: z.iso.date().optional().catch(undefined),
    to: z.iso.date().optional().catch(undefined),
  }),
  beforeLoad: ({
    search: { tab, whId, binId, subBinId, from, to, ...rest },
  }) => {
    if (tab === "bin-card")
      throw redirect({
        to: "/stores/reports/bin-card",
        search: { whId, binId, subBinId, from, to },
      });
    if (tab === "sloc-search" || tab === "item-search")
      throw redirect({
        to: "/stores/reports/$key",
        params: { key: "sloc-status" },
        search: {
          whId,
          binId,
          subBinId,
          classificationId: rest.classificationId,
          itemId: rest.itemId,
        },
      });
    throw redirect({ to: "/stores/reports" });
  },
});
